export function getErrorMessage(error: unknown, fallback: string): string {
  return (error as any)?.response?.data?.error || fallback;
}
